// Portado de src/components/tratamento/Hero.astro (site Astro).
import { useAgendamentoLink } from "@/lib/itv/agendamento";

export interface HeroTrilhaItem {
  nome: string;
  href?: string;
}

export interface HeroProps {
  trilha: HeroTrilhaItem[];
  sobretitulo: string;
  linha1: string;
  linha2: string;
  chamada: string;
  imagem: string;
  botao?: string;
}

export function Hero({ trilha, sobretitulo, linha1, linha2, chamada, imagem, botao = "Agendar avaliação" }: HeroProps) {
  const agendar = useAgendamentoLink();
  return (
    <section className="hero">
      <div className="hero-fundo" aria-hidden="true">
        <img
          src={imagem.replace(/\.(png|jpg|jpeg)$/i, ".webp")}
          alt={`${linha1} ${linha2}`}
          width={1024}
          height={1024}
          loading="eager"
          fetchPriority="high"
        />
        <span className="hero-veu" />
      </div>
      <div className="container hero-inner">
        <nav className="trilha" aria-label="Você está em">
          {trilha.map((t, i) => (
            <span key={i}>
              {i > 0 && <span aria-hidden="true"> › </span>}
              {t.href ? <a href={t.href}>{t.nome}</a> : <span>{t.nome}</span>}
            </span>
          ))}
        </nav>
        <p className="hero-sobretitulo">{sobretitulo}</p>
        <h1>
          {linha1}
          <br />
          <em>{linha2}</em>
        </h1>
        <p className="hero-chamada">{chamada}</p>
        <a className="btn-ouro hero-btn" href={agendar}>
          {botao}
        </a>
      </div>
    </section>
  );
}
